const guidelineItems = [
  "情報資産の機密性、完全性、可用性を確実に保護するために組織的、技術的に適切な対策を講じ、変化する情報技術や新たな脅威に対応します。",
  "全社員に情報セキュリティ教育の実施と方針の周知徹底をはかり、意識の高揚・維持に務めます。",
  "マネジメントシステム及び、情報セキュリティに関する目的を設定し、定期的にレビューし、継続的に改善を実施し、維持します。",
  "マネジメントシステムを実行・維持・改善して行くために管理責任者に責任と権限を委譲します。",
];

const SecurityContent = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        {/* 基本理念 */}
        <div className="mb-20">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#5DAA68]/10">
              <i className="ri-shield-check-line text-lg text-[#5DAA68]"></i>
            </div>
            <h4 className="text-xl md:text-2xl font-bold text-[#89B56B] font-['Noto_Sans_JP']">
                基本理念
            </h4>
          </div>
          <div className="border-t border-[#89B56B]/20"></div>

          <div className="mt-5 bg-white rounded-2xl shadow-[0_4px_24px_rgba(137,181,107,0.08)] p-8 md:p-10">
            <p className="text-[13px] md:text-sm text-gray-700 leading-[1.9] pl-4 border-l-2 border-[#89B56B]/20">
              株式会社MSKは、当社に関わる情報を適切に管理し、当社の事業に関わる全ての人々の満足を得る事を目標として、信頼・安心される会社を目指します。
            </p>
          </div>
        </div>

        {/* 行動指針 */}
        <div className="mb-20">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#5DAA68]/10">
              <i className="ri-compass-3-line text-lg text-[#5DAA68]"></i>
            </div>
            <h4 className="text-xl md:text-2xl font-bold text-[#89B56B] font-['Noto_Sans_JP']">
                行動指針
            </h4>
          </div>
          <div className="border-t border-[#89B56B]/20"></div>

          <div className="mt-5 bg-white rounded-2xl shadow-[0_4px_24px_rgba(137,181,107,0.08)] p-8 md:p-10">
            <ul className="space-y-5">
              {guidelineItems.map((item, index) => (
                <li key={index} className="flex items-start gap-4 group">
                  <span className="flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-full bg-[#89B56B]/10 text-[#5DAA68] text-xs font-bold mt-0.5 group-hover:bg-[#5DAA68] group-hover:text-white transition-colors">
                    {index + 1}
                  </span>
                  <p className="text-[13px] md:text-sm text-gray-700 leading-[1.9] pt-0.5">{item}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* 制定情報 */}
        <div className="flex justify-end">
          <div className="text-right space-y-1.5">
            <p className="text-[13px] md:text-sm text-gray-700 font-bold">制定日　2020年5月1日</p>
            <p className="text-[13px] md:text-sm text-gray-700 font-bold">株式会社MSK</p>
            <p className="text-[13px] md:text-sm text-gray-700 font-bold">代表取締役　春日 啓悟</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SecurityContent;
